"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marsala": {
    "cb83e962": [{
      "hkey": "a81226c6",
      "slug": "birgi-dammusello-spagnola-stagnone",
      "name": "Birgi-Dammusello-Spagnola-Stagnone",
      "primary": true,
      "skipSearch": false
    }],
    "birgi": [{
      "hkey": "a81226c6",
      "slug": "birgi-dammusello-spagnola-stagnone",
      "name": "Birgi-Dammusello-Spagnola-Stagnone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "e64f1367": [{
      "hkey": "784b0078",
      "slug": "marsala",
      "name": "Marsala",
      "primary": true,
      "skipSearch": false
    }],
    "bosco": [{
      "hkey": "784b0078",
      "slug": "marsala",
      "name": "Marsala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db9a0cbd": [{
      "hkey": "9af910c4",
      "slug": "contrade-extraurbane",
      "name": "Contrade Extraurbane",
      "primary": true,
      "skipSearch": false
    }],
    "ciavalotto": [{
      "hkey": "9af910c4",
      "slug": "contrade-extraurbane",
      "name": "Contrade Extraurbane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "marsala"
    }],
    "ee637af7": [{
      "hkey": "9af910c4",
      "slug": "contrade-extraurbane",
      "name": "Contrade Extraurbane",
      "primary": true,
      "skipSearch": false
    }],
    "paolini": [{
      "hkey": "9af910c4",
      "slug": "contrade-extraurbane",
      "name": "Contrade Extraurbane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "818a0ff9": [{
      "hkey": "784b0078",
      "slug": "marsala",
      "name": "Marsala",
      "primary": true,
      "skipSearch": false
    }],
    "ranna": [{
      "hkey": "784b0078",
      "slug": "marsala",
      "name": "Marsala",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2cd912b3": [{
      "hkey": "9af910c4",
      "slug": "contrade-extraurbane",
      "name": "Contrade Extraurbane",
      "primary": true,
      "skipSearch": false
    }],
    "strasatti": [{
      "hkey": "9af910c4",
      "slug": "contrade-extraurbane",
      "name": "Contrade Extraurbane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "marsala"
    }],
    "cb1e755b": [{
      "hkey": "9af910c4",
      "slug": "contrade-extraurbane",
      "name": "Contrade Extraurbane",
      "primary": true,
      "skipSearch": false
    }],
    "terrenove": [{
      "hkey": "9af910c4",
      "slug": "contrade-extraurbane",
      "name": "Contrade Extraurbane",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "marsala"
    }]
  }
};
exports["default"] = _default;